import { useLayoutEffect } from "react";

import { formatPageTitle } from "hooks/usePageTitle";

/**
 * Set the tab title for a route, falling back to the app name with no title
 */
export default function RouteTitle({
  title,
  children,
}: {
  title?: string;
  children: React.ReactNode;
}) {
  // Layout effect runs before the page's own `usePageTitle` (a passive effect),
  // so a page can refine this title on mount.
  useLayoutEffect(() => {
    document.title = formatPageTitle(title);
  }, [title]);

  return <>{children}</>;
}
